import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow\">\n<path d=\"M-1.04907e-06 1.90735e-06L0 24L24 24L24 8.58275e-07L-1.04907e-06 1.90735e-06Z\" fill=\"white\" fill-opacity=\"0.01\" />\n<path d=\"M16 10L12 14L8 10\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol